export const generateRoute = (path, element): Route => ({
    path,
    element,
});
